
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"100","height":"100","viewBox":"0 0 100 100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('search')]),_c('g',{attrs:{"filter":"url(#filter0_b_5162_10628)"}},[_c('circle',{attrs:{"cx":"50","cy":"50","r":"50","fill-opacity":"0.4"}})]),_c('g',{attrs:{"clip-path":"url(#clip0_5162_10628)"}},[_c('path',{attrs:{"d":"M44.7152 38.5429C43.3826 37.7228 41.667 38.6815 41.667 40.2462V59.7546C41.667 61.3192 43.3826 62.2779 44.7152 61.4579L60.5658 51.7037C61.8348 50.9227 61.8348 49.078 60.5658 48.2971L44.7152 38.5429Z","fill":"currentColor"}})]),_c('defs',[_c('filter',{attrs:{"id":"filter0_b_5162_10628","x":"-35","y":"-35","width":"170","height":"170","filterUnits":"userSpaceOnUse","color-interpolation-filters":"sRGB"}},[_c('feFlood',{attrs:{"flood-opacity":"0","result":"BackgroundImageFix"}}),_c('feGaussianBlur',{attrs:{"in":"BackgroundImageFix","stdDeviation":"17.5"}}),_c('feComposite',{attrs:{"in2":"SourceAlpha","operator":"in","result":"effect1_backgroundBlur_5162_10628"}}),_c('feBlend',{attrs:{"mode":"normal","in":"SourceGraphic","in2":"effect1_backgroundBlur_5162_10628","result":"shape"}})]),_c('clipPath',{attrs:{"id":"clip0_5162_10628"}},[_c('rect',{attrs:{"width":"40","height":"40","fill":"currentColor","transform":"translate(30 30)"}})])])])
          )
        }
      }
    